<template>
  <div class="email-autocomplete-wrapper" :class="{ 'is-main': is_main, 'is-secondary': !is_main }">
    <div class="email-field-container">
      <div class="field-label" v-if="textSuggest">
        <span class="label-text">{{ textSuggest }}</span>
        <div class="label-actions" v-if="is_main">
          <button
            type="button"
            :class="['action-btn', { active: cc_visible }]"
            @click="makeCCVisible()"
          >
            {{ $t('components.email.inputs.autocomplete.cc') }}
          </button>
          <span class="action-divider"></span>
          <button
            type="button"
            :class="['action-btn', { active: bcc_visible }]"
            @click="makeBCCVisible()"
          >
            {{ $t('components.email.inputs.autocomplete.bcc') }}
          </button>
        </div>
      </div>
      <v-combobox
        class="email-autocomplete-input"
        v-model="recipients"
        :items="availableEmails"
        hide-details
        hide-selected
        multiple
        :menu-props="{
          bottom: true,
          offsetY: true,
          contentClass: 'email-autocomplete-menu',
          maxHeight: 280
        }"
        :loading="is_loading_vals"
        @keyup="activateSearch"
        @input="changedArr()"
      >
        <template v-slot:selection="{ item, index }">
          <div class="email-chip" :key="index">
            <span class="email-chip-text">{{ item }}</span>
            <button
              type="button"
              class="email-chip-remove"
              @click.stop="removeRecipient(index)"
            >
              <v-icon size="14">mdi-close</v-icon>
            </button>
          </div>
        </template>
        <template v-slot:item="{ item }">
          <div class="email-suggestion-item">
            <div class="suggestion-avatar">
              <v-icon size="18" color="#372EAA">mdi-account</v-icon>
            </div>
            <span class="suggestion-email">{{ item }}</span>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="email-loading" v-if="is_loading_vals">
            <div class="loading-spinner">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke-width="3" stroke="#e3e5ee" fill="none"/>
                <circle cx="12" cy="12" r="10" stroke-width="3" stroke="#372EAA" fill="none" stroke-dasharray="31.4 31.4" stroke-linecap="round"/>
              </svg>
            </div>
            <span>{{ $t('components.email.inputs.autocomplete.searching') || 'Searching...' }}</span>
          </div>
          <div class="email-no-data" v-else>
            <v-icon size="20" color="#9ca3af">mdi-email-search-outline</v-icon>
            <span>{{ $t('components.email.inputs.autocomplete.type_to_search') || 'Type to search emails...' }}</span>
          </div>
        </template>
      </v-combobox>
    </div>
  </div>
</template>

<script>
import { searchGraphPeopleEmail } from "../../../apiCallers/graph/email/email.getters";
export default {
  props: {
    is_main: {
      type: Boolean,
      default: false,
    },
    previous_filled_emails: {
      type: Array,
      default: [],
    },
    textSuggest: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      recipients: [],
      timeout: setTimeout(function () {}, 0),
      textual_search: "",
      availableEmails: [],

      //   flags
      initial_setup_flag: false,

      cc_visible: false,
      bcc_visible: false,
      is_loading_vals: false,
    };
  },
  watch: {
    textual_search: function () {
      console.log("tu je");
    },

    recipients: function () {
      if (this.initial_setup_flag) {
        this.$emit("emailArrayChange", this.recipients);
      }
    },
  },
  methods: {
    changedArr()
    {
      console.log("changed arr")
      this.recipients = this.recipients.filter(p=> /.+@.+\..+/.test(p))
    },
    activateSearch(event) {
      this.is_loading_vals = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (event.target.value.trim().length > 0) {
          this.graphSearchEmails(event.target.value);
        }else{
            this.availableEmails = [];
            this.is_loading_vals = false;
        }
      }, 1000);
    },

    async graphSearchEmails(srch_string) {
      this.availableEmails = [];
      this.is_loading_vals = true;

      try {
        await searchGraphPeopleEmail(srch_string, 0, 25).then((resp) => {
          console.log("Response with emails", resp);
          this.availableEmails = resp;
          this.is_loading_vals = false;
        });
      } catch {
        this.is_loading_vals = false;
      }
    },
    makeCCVisible() {
      this.cc_visible = !this.cc_visible;
      this.$emit("ccVisible", this.cc_visible);
    },
    makeBCCVisible() {
      this.bcc_visible = !this.bcc_visible;
      this.$emit("bccVisible", this.bcc_visible);
    },
    removeRecipient(index) {
      this.recipients.splice(index, 1);
      this.$emit("emailArrayChange", this.recipients);
    },
  },
  mounted() {
    this.recipients = this.previous_filled_emails;
    this.initial_setup_flag = true;
  },
};
</script>

<style scoped>
.email-autocomplete-wrapper {
  margin-bottom: 16px;
}

.email-autocomplete-wrapper.is-main {
  margin-bottom: 20px;
}

.email-autocomplete-wrapper.is-secondary {
  margin-bottom: 12px;
}

.email-field-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px;
}

.label-text {
  font-family: "Barlow", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #606076;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.label-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-btn {
  background: none;
  border: none;
  font-family: "Barlow", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 12px;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.action-btn:hover {
  color: #372EAA;
  background-color: #F0F1FD;
}

.action-btn.active {
  color: #ffffff;
  background-color: #372EAA;
}

.action-divider {
  width: 1px;
  height: 16px;
  background-color: #e5e7eb;
}

/* Email chip styles */
.email-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #F0F1FD 0%, #E8E9F8 100%);
  border: 1px solid #d4d6f0;
  border-radius: 20px;
  padding: 4px 8px 4px 12px;
  margin: 3px 4px 3px 0;
  max-width: 220px;
  transition: all 0.2s ease;
}

.email-chip:hover {
  background: linear-gradient(135deg, #E8E9F8 0%, #DBD9F7 100%);
  border-color: #b5b8e8;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(55, 46, 170, 0.12);
}

.email-chip-text {
  font-family: "Barlow", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #2b2b41;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.email-chip-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.email-chip-remove:hover {
  background-color: rgba(55, 46, 170, 0.15);
}

.email-chip-remove .v-icon {
  color: #606076 !important;
  transition: color 0.2s ease;
}

.email-chip-remove:hover .v-icon {
  color: #372EAA !important;
}

/* Suggestion item styles */
.email-suggestion-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  width: 100%;
  transition: background-color 0.15s ease;
}

.suggestion-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #F0F1FD 0%, #E8E9F8 100%);
  border-radius: 50%;
  flex-shrink: 0;
}

.suggestion-email {
  font-family: "Barlow", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #2b2b41;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* No data state */
.email-no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px 16px;
  color: #9ca3af;
  font-family: "Barlow", sans-serif;
  font-size: 13px;
  font-weight: 500;
}

/* Loading state */
.email-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px 16px;
  color: #372EAA;
  font-family: "Barlow", sans-serif;
  font-size: 13px;
  font-weight: 600;
}

.loading-spinner {
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

.loading-spinner svg {
  width: 100%;
  height: 100%;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<style>
/* Global styles for the autocomplete menu and input */
.email-autocomplete-input.v-input {
  margin: 0;
  padding: 0;
}

.email-autocomplete-input .v-input__control {
  min-height: 44px !important;
}

.email-autocomplete-input .v-input__slot {
  background: #f8f9fc !important;
  border: 1.5px solid #e3e5ee !important;
  border-radius: 12px !important;
  padding: 6px 12px !important;
  min-height: 44px !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04) !important;
}

.email-autocomplete-input .v-input__slot:hover {
  border-color: #c7cae8 !important;
  background: #ffffff !important;
}

.email-autocomplete-input.v-input--is-focused .v-input__slot {
  border-color: #372EAA !important;
  background: #ffffff !important;
  box-shadow: 0 0 0 3px rgba(55, 46, 170, 0.1) !important;
}

.email-autocomplete-input .v-select__selections {
  min-height: 32px !important;
  padding: 2px 0 !important;
  flex-wrap: wrap;
  gap: 2px;
}

.email-autocomplete-input .v-select__selections input {
  font-family: "Barlow", sans-serif !important;
  font-size: 14px !important;
  color: #2b2b41 !important;
  padding: 4px 8px !important;
  min-width: 120px !important;
}

.email-autocomplete-input .v-select__selections input::placeholder {
  color: #9ca3af !important;
  font-weight: 400 !important;
}

.email-autocomplete-input .v-input__append-inner {
  align-self: center;
  margin-top: 0 !important;
  padding-left: 4px !important;
}

.email-autocomplete-input .v-progress-linear {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
}

.email-autocomplete-input .v-progress-linear__background,
.email-autocomplete-input .v-progress-linear__indeterminate {
  background-color: #372EAA !important;
}

/* Remove default Vuetify underlines */
.email-autocomplete-input .v-input__slot::before,
.email-autocomplete-input .v-input__slot::after {
  display: none !important;
}

/* Dropdown menu styling */
.email-autocomplete-menu {
  border-radius: 12px !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(55, 46, 170, 0.08) !important;
  border: 1px solid #e5e7eb !important;
  margin-top: 6px !important;
  overflow: hidden !important;
}

.email-autocomplete-menu .v-list {
  padding: 8px 0 !important;
  background: #ffffff !important;
}

.email-autocomplete-menu .v-list-item {
  min-height: auto !important;
  padding: 0 !important;
  margin: 0 8px !important;
  border-radius: 8px !important;
  transition: background-color 0.15s ease !important;
}

.email-autocomplete-menu .v-list-item:hover {
  background-color: #F0F1FD !important;
}

.email-autocomplete-menu .v-list-item--active {
  background-color: #E8E9F8 !important;
}

.email-autocomplete-menu .v-list-item--active .suggestion-email {
  color: #372EAA;
  font-weight: 600;
}

.email-autocomplete-menu .v-list-item__content {
  padding: 0 !important;
}

/* Loading state animation */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.email-autocomplete-input.v-input--is-loading .v-input__slot {
  background: linear-gradient(
    90deg,
    #f8f9fc 25%,
    #f0f1fd 50%,
    #f8f9fc 75%
  ) !important;
  background-size: 200% 100% !important;
  animation: shimmer 1.5s infinite !important;
}
</style>
